<template>
    <b-overlay :show="submitting || updating || generalDeleting" rounded="sm">
    <div class="health-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="close-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
                <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                    <b-row>
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $nameLabel() }}<span class="red">*</span> </strong></label>
                            <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()" v-model="model.name"
                                required :placeholder="$translate('enter_name')" trim></b-form-input>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('document_type') }}<span class="red">*</span> </strong></label>
                              <b-form-select
                                id="input-document_type"
                                v-model="model.document_type_id"
                                :options="document_types"
                                required
                              ></b-form-select> 
                            </b-col>
                            <b-col cols="12" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('document_id') }}</strong></label>
                                <b-form-input type="text" id="input-document_id" v-custom-validation="$textRequired()" v-model="model.document_id"
                                     :placeholder="$translate('enter_document_id')" trim></b-form-input>
                            </b-col>
                        
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('description') }}</strong>
                            </label>
                            <b-form-textarea id="input-description" v-model="model.description"
                                :placeholder="$translate('enter_description')" rows="3"></b-form-textarea>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('instructions') }}</strong>
                            </label>
                            <b-form-textarea id="input-instructions" v-model="model.instructions"
                                :placeholder="$translate('enter_instructions')" rows="3"></b-form-textarea>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{$translate('google_sheet_link')  }} </strong></label>
                            <b-form-input type="text" id="input-link" v-custom-validation="$textRequired()" v-model="model.link"
                                 :placeholder="$translate('enter_link')" trim></b-form-input>
                        </b-col>
                        <b-row class="mt-3">
                            <b-col cols="12" class="mb-3">
                                <label><strong>{{ $translate('link_permission') }}</strong></label>
                            </b-col>
                            <b-col cols="auto" class="mb-3">
                                <b-form-radio
                                    v-model="model.permission"
                                    name="permission"
                                    value="read_only"
                                    class="mx-1"
                                >&nbsp;{{$translate('share_master')}}</b-form-radio>
                            </b-col>
                            <b-col cols="auto" class="mb-3">
                                <b-form-radio
                                    v-model="model.permission"
                                    name="permission"
                                    value="edit"
                                    class="mr-2"
                                >&nbsp;{{$translate('share_copy_master')}}</b-form-radio>
                            </b-col>
                        </b-row>
                        <b-col cols="12" class="mt-3" v-if="model.permission !== 'read_only'">
                            <label class="mb-3"><strong>{{ $translate('destionation_folder') }}</strong></label>
                            <b-form-input type="text" id="input-folder_id" v-custom-validation="$textRequired()" v-model="model.folder_id"
                                 :placeholder="$translate('enter_folder_id')" trim></b-form-input>
                        </b-col>
                            <b-col cols="12" class="mt-3">
                                <label class="mb-3"><strong>{{$translate('attachments')  }} </strong></label>
                              <view-attachments :view-mode="isView" :is-new="isNew" />
                            </b-col>
                         
                        <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                            <b-button id="submit-btn" variant="info"  v-if="hasPermissionUpdate"   type="submit" class="btn-fw"
                                :disabled="submitting ? true : false">{{ submitLabel }}
                            </b-button>
                            <!-- <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button> -->
                            <!-- <b-button v-if="hasPermissionDelete && !isNew" @click="deletehealth()" class="float-right"
                                variant="delete-button" size="fw">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button id="delete-btn" v-if="!isNew && hasPermissionDelete " @click="delete_document_type()" class="float-right"
                            variant="delete-button" size="fw">
                            {{ $deleteLabel() }}
                        </b-button>
                            <b-button id="cancel-btn" variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                                {{ $cancelLabel() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ViewAttachments from "./ViewAttachments.vue";

export default {
    name: 'Master Document',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    components:{
        ViewAttachments
    },
    data() {
        return {
            model: {
                id: 0,
                name: '',
                description:''
            },

            updating: false,

            submitting: false,
            isView : false,
        }
    },
    created() {
    this.loadDocumentTypes();
    },
    computed: {
        componentName() { return this.$translate('master_document') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_master_document') : this.$translate('master_document')
        },
        master_document() {
            const master_document = { ...this.$store.state.master_document.document_type }
          
          
            return master_document
        },
        document_types(){
          
            return this.$store.state.master_document.document_types.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
      
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
        assetAttachments() {
            return this.$store.state.masterdocAttachmentsStore.attachments
         },
    },
    watch: {
        master_document: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            this.$store.commit("master_document/clearAssetsAttachments",[]);
            this.$store.commit("masterdocAttachmentsStore/clearAssetAttachments",[]);
            this.$router.push('/ams/master-document')
        },

        CreateOrUpdate() {
            this.submitting = true;
            const { assetAttachments: attachments } = this;
            const payload = {
          ...this.model,
          attachments
        };
            this.$validator.validate().then(valid => {
                if (valid) {

                    console.log('attachments',attachments);
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'master_document/update' : 'master_document/create',
                            payload
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({ name: 'MasterDocument' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({ name: 'MasterDocument' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },

        async delete_document_type() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/ams/master-document',
                deleteRoute: 'master_document/delete',
            }
            const notificationFields = {
                type: 'Document Type',
                errorMsg: this.$translate('unable_master_document_alert'),
            }
            try {
                const result = await this.deleteItem(notificationFields, model, routes);
                if (result){
                    this.submitting = true;
                    this.$emit('success');
                }
            } catch (error) {
                console.error(error);
                this.doToast(this.$translate('error'), this.$translate('unable_alert'), 'danger');
            } finally {
                this.submitting = false;
            }
        },
        async loadDocumentTypes() {
             await this.$store.dispatch('master_document/fetchDocumentTypes');
        }
    },
    async mounted() {
        if (this.$route.params.id !== 0) {
            this.$store.dispatch('master_document/fetchById', this.$route.params.id);
            await this.$store.dispatch("master_document/fetchAttachments", this.$route.params.id);
        }
       
       
    },
}
</script>
<style></style>
